import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Director } from '../../models/director';
import { DirectorService } from '../../services/director.service';
import { CoreSaveService, ConfigService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { DatePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { Designation } from '../../models/designation';
import { DesignationService } from '../../services/designation.service';



import { FormsModule } from '@angular/forms';
import { FileUploaderService } from '../../services/fileuploader.service';
import { DirectorEducationalQualification } from '../../models/directoreducationalqualification';
import { DirectorFormsFiledAndIntimations } from '../../models/directorformfiledandintimations';
import { DirectorOtherEnclosure } from '../../models/directorotherenclosures';
import { Console } from 'console';
import { DocumentServerService } from '../../services/documentdownload.Service';


//-------------  Imported Modules -------------------------

@Component({
  selector: 'app-director',
  templateUrl: './director.component.html',
  styleUrls: ['./director.component.css']
})
export class DirectorComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  directorEducationalQualification: DirectorEducationalQualification = new DirectorEducationalQualification();
  directorFormsFiledAndIntimations: DirectorFormsFiledAndIntimations = new DirectorFormsFiledAndIntimations();
  directorOtherEnclosure: DirectorOtherEnclosure = new DirectorOtherEnclosure();


  headerDirector: PageHeader;
  entity: Director = new Director();
  editingEntity: Director = new Director();
  selectedDirector: Director = new Director();
  directors: any;
  data: any;
  opened: boolean = false;
  details: any;
  directorColumns: any[] = [];
  listView: boolean = true;
  formCaption: string = '';
  pipe = new DatePipe('en-US');
  emailcheck: boolean = true;
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  QualificationColumns: any[] = [];
  ProExperienceColumns: any[] = [];
  FormFiledColumns: any[] = [];
  otherColumns: any[] = [];
  saveDisabled: boolean = false;
  EduDisabled: boolean = false;
  ProDisabled: boolean = false;
  FormDisabled: boolean = false;
  OtherDisabled: boolean = false;
  SubmitDisabled: boolean = false;

  path: string = "";
  fileName: string = "";
  EduQualificationCaption: string = '';
  ProExperienceCaption: String = '';
  FormFiledCaption: string = '';
  OtherEnclosureCaption: string = '';
  url = '';
  url_ = '';
  url_DIN = '';
  designations: Array<Designation> = [];
  DirectorEducationalQualification: Array<DirectorEducationalQualification>;
  // editDirectorEducationalQualification: Array<DirectorEducationalQualification>=[];
  // DirectorProfessionalExperience: Array<DirectorProfessionalExperience>;
  // DirectorFormsFiledAndIntimations: Array<DirectorFormsFiledAndIntimations>;
  // DirectorOtherEnclosure: Array<DirectorOtherEnclosure>;
  isButtonVisible: boolean = false;
  isButtonVisible_din: boolean = false;
  selectedDesignation: any;
  entities: any = [{}];
  entities_EDU: any = [{}];
  entities_PRO: any = [{}];
  entities_FORMS: any = [{}];
  entities_OTHER: any = [{}];
  TabArray: any = [];
  ProfessionalArray: any = [];
  appModeList: Array<any> = [];
  savedoc: boolean = false;
  DINurl = '';
  DINisButtonVisible: boolean = false;

  PANurl = '';
  PANisButtonVisible: boolean = false;

  Aadharurl = '';
  AadharisButtonVisible: boolean = false;
  DOBurl = '';
  DOBisButtonVisible: boolean = false;
  DOAurl = '';
  DOAisButtonVisible: boolean = false;
  DOReAppurl = '';
  DOREAisButtonVisible: boolean = false;
  FIurl = '';
  FIisButtonVisible: boolean = false;
  Membershipurl = '';
  MembershipisButtonVisible: boolean = false;
  Istextbox: boolean = false;
  aciveTab: number = 0;
  contactCheck: boolean = true;
  maxlength: number = 500;
  panCheck: boolean = true;
  aadharCheck: boolean = true;
  QualificationCheck: boolean = true;
  Isvalidation: boolean = false;

  PANdownload: any;
  DINdownload: any;
  Aadhaardownload: any;
  DOBdownload: any;
  DOAdownload: any;
  ReAppointmentDatedownload: any;
  Membershipdownload: any;
  dataItemdonload: any;
  isDownloadButtonVisible: boolean = false;
  proofTypes: Array<any> = [
    {
      proofType: "DIN",
      displayName: "DIN",
      refId: "",
      description: "Enter the DIN",
      value: "",
      url: this.DINurl,
      button: this.DINisButtonVisible,
      Istextbox: true,
      maxlength: 8,
      validationMessage: "DIN is required"

    },


    {
      proofType: "PAN",
      displayName: "PAN",
      description: "Enter the PAN",
      url: this.PANurl,
      button: this.PANisButtonVisible,
      Istextbox: true,
      value: "",
      maxlength: 10,
      validationMessage: "PAN is required"
    },
    {
      proofType: "Aadhaar",
      displayName: "Aadhaar",
      description: "Enter the Aadhaar",
      url: this.Aadharurl,
      button: this.AadharisButtonVisible,
      Istextbox: true,
      value: "",
      maxlength: 14,
      validationMessage: "Aadhaar is required"
    },
    // {
    //   proofType: "FI",
    //   displayName: "Forms Filed and Intimations",
    //   description: "Enter the Forms Filed and Intimations",
    //   url: this.FIurl,
    //   value: "",
    //   button: this.FIisButtonVisible,
    //   Istextbox:true,
    // }, 
    {
      proofType: "DOB",
      displayName: "DOB",
      description: "Enter the DOB",
      url: this.DOBurl,
      button: this.DOBisButtonVisible,
      Istextbox: false,
      value: "",
      validationMessage: "DOB is required"
    }, {
      proofType: "DOA",
      displayName: "Date of Appointment",
      description: "Enter the Date of Appointment",
      url: this.DOAurl,
      button: this.DOAisButtonVisible,
      Istextbox: false,
      value: "",
      validationMessage: "DOA is required"
    },
    {
      proofType: "ReAppointmentDate",
      displayName: "Re-Appointment",
      description: "Enter the Date of Re-Appointment",
      url: this.DOReAppurl,
      button: this.DOREAisButtonVisible,
      Istextbox: false,
      value: "",
      validationMessage: "ReAppointment is required"
    }, {
      proofType: "Membership",
      displayName: "Membership",
      description: "Enter the Membership",
      url: this.Membershipurl,
      button: this.MembershipisButtonVisible,
      Istextbox: false,
      value: 0,
      validationMessage: "Membership is required"
    },
  ]
  constructor(
    private _directorService: DirectorService,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private _designationService: DesignationService,
    private fileUploader: FileUploaderService,
    private documentdownloadservice: DocumentServerService,

  ) {
    this.headerDirector = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.appModeList = [{}];
    this.directors = [];
    this.DirectorEducationalQualification = [];
    this.getAllDirectors();
  }
  ngAfterViewInit(): void {
    this.directorColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 50 },
      { field: "DirectorName", title: 'Name', filter: true, sortable: true, width: 120 },
      { field: "DesignationName", title: 'Designation Name', filter: true, sortable: true, width: 120 },
      { field: "EmailId", title: 'Email', filter: true, sortable: true, width: 100 },
      { field: "Phone", title: 'Phone', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];

    this.QualificationColumns = [
      { field: "", title: '', filter: false, sortable: false, width: 5 },
      { field: "SlNo", title: 'SL No', filter: false, sortable: true, width: 20 },
      { field: "QualificationName", title: 'Educational Qualification', filter: true, sortable: true, width: 70 },
    ];

    this.ProExperienceColumns = [
      { field: "", title: '', filter: true, sortable: true, width: 5},
      { field: "SlNo", title: 'SL No', filter: false, sortable: true, width: 20 },
      { field: "ProfessionalName", title: 'Professional Experience', filter: true, sortable: true, width: 70 },
      { field: "Experience_Year", title: 'Experience Year', filter: true, sortable: true, width: 70 },
    ];

    this.FormFiledColumns = [
      { field: "", title: '', filter: true, sortable: true, width: 5 },
      { field: "SlNo", title: 'SL No', filter: false, sortable: true, width: 20 },
      { field: "FormFiledName", title: 'Forms Filed and Intimations', filter: true, sortable: true, width: 70 },
    ];

    this.otherColumns = [
      { field: "", title: '', filter: true, sortable: true, width: 5 },
      { field: "SlNo", title: 'SL No', filter: false, sortable: true, width: 20 },
      { field: "Tittle", title: 'Other Enclosures', filter: true, sortable: true, width: 70 },
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._directorService.getAllDirector('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((directors: Array<Director>) => {
      this.directors = {
        data: directors,
        total: directors[0] ? directors[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._directorService.getAllDirector(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((directors: Array<Director>) => {
        this.directors = {
          data: directors,
          total: directors[0] ? directors[0].TotalCount : 0
        }
      });
    }
  }
  getAllDirectors() {
    this._directorService.getAllDirector('', Number(this.defaultPageSize), 1, 0, 0).subscribe((directors: Array<Director>) => {
      this.directors = {
        data: directors,
        total: directors[0].TotalCount
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._directorService.deleteDirector(this.selectedDirector.Director_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearDirector();
            this.getAllDirectors();
          },
          )
        }
      }
    });
  }

  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  initPageHeader(): PageHeader {
    let headerDirector = new PageHeader();
    headerDirector.PageCaption = "Director";
    headerDirector.IconClass = "bi bi-building";
    return headerDirector;
  }

  deleteDirector(event: any) {
    if (event.seletedRows[0]) {
      this.selectedDirector.Director_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Director",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addDirector(event: any) {
    this.listView = false;
    this.isDownloadButtonVisible=false; //added on 18-06-2024 by jessil for #I224 4.The download button should not be displayed once we add a new Director.it should only appear after saving. However, if we click edit and view a Director's record, then close it and try to add a new Director, the download button is displayed.The should be page refresh -New
    this.clearDirector();
    this.formCaption = "Add Director";
    this.getAllDesignations('');
    this.aciveTab = 0;
    setTimeout(() => {
      this.goToNextTab();
    }, 100);

  }

  getUTCDate(localDate: Date): Date {

    return new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(),
      localDate.getHours(), localDate.getMinutes()));
  }

  editDirector(event: any): void {
    this.isDownloadButtonVisible=true;
    if (event.seletedRows[0]) {
      this._directorService.viewDirector(event.seletedRows[0]).subscribe((directors: any) => {
        this.aciveTab = 0;
        let editDirector = directors;
        if (editDirector) {
          this.editingEntity = editDirector;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.DINdownload = ""; this.PANdownload = ""; this.DOAdownload = ""; this.DOBdownload = ""; this.ReAppointmentDatedownload = "";
          this.Membershipdownload = ""; this.Aadhaardownload = "";

          // this.TabArray = this.editingEntity.DirectorEducationalQualification;
          this.entities_EDU = this.editingEntity.DirectorEducationalQualification;
          this.entities_PRO = this.editingEntity.DirectorProfessionalExperience;
          this.entities_FORMS = this.editingEntity.DirectorFormsFiledAndIntimations;
          this.entities_OTHER = this.editingEntity.DirectorOtherEnclosure;
          this.proofTypes = [
            { proofType: "DIN", displayName: "DIN", value: this.editingEntity.DIN, Istextbox: true, maxlength: 8 },
            { proofType: "Aadhaar", displayName: "Aadhaar", value: this.editingEntity.Aadhar, Istextbox: true, maxlength: 14 },
            { proofType: "PAN", displayName: "PAN", value: this.editingEntity.PAN, Istextbox: true, maxlength: 10 },
            { proofType: "DOB", displayName: "DOB", value: this.getUTCDate(new Date(this.editingEntity.DOB)), Istextbox: false },
            { proofType: "DOA", displayName: "Date of Appointment", value: this.getUTCDate(new Date(this.editingEntity.AppointmentDate)), Istextbox: false },
            { proofType: "ReAppointmentDate", displayName: "Date of Re-Appointment", value: this.getUTCDate(new Date(this.editingEntity.ReAppointmentDate)), Istextbox: false },
            { proofType: "Membership", displayName: "Membership", value: this.editingEntity.Membership, Istextbox: false }
          ]
          this.selectedDesignation = { Designation_Id: this.editingEntity.Designation_Id, DesignationName: this.editingEntity.DesignationName };
          this.formCaption = "Edit Director";
          this.getAllDesignations('');
          setTimeout(() => {
            this.goToNextTab();
          }, 100);
          this.entity.EntityMetaData = [
            { FieldName: 'DirectorName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Director Name is required' },
            { FieldName: 'Designation_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Designation is required' },
            // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            // { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
          ];
        }
      });
    }
  }
  initializeSaveEntity(entity: Director): Director {
    for (let index = 0; index < this.proofTypes.length; index++) {
      if (this.proofTypes[index].proofType === "DIN") {
        // entity.DIN_Ref_Id = this.proofTypes[index].refId;
        entity.DIN = this.proofTypes[index].value;
      }

    }
    return entity;
  }

  Setvalues(event: any, type: any): void {

    for (let row = 0; row < this.proofTypes.length; row++) {
      if (this.proofTypes[row].proofType == "DIN") {
        this.fileUploader.upload(this.proofTypes[row].Document, '').subscribe((result: any) => {
          if (result.succeeded) {
            if (this.proofTypes[row].proofType == "DIN") {
              this.entity.DIN = this.proofTypes[row].value;
              this.entity.DIN_Ref_Id = result.documentId;

            }
          }
        }
        )
      }


      if (this.proofTypes[row].proofType == "PAN") {
        this.entity.PAN = this.proofTypes[row].value

      }
      if (this.proofTypes[row].proofType == "Aadhaar") { this.entity.Aadhar = this.proofTypes[row].value }
      if (this.proofTypes[row].proofType == "DOB") { this.entity.DOB = this.proofTypes[row].value }
      if (this.proofTypes[row].proofType == "DOA") { this.entity.AppointmentDate = this.proofTypes[row].value }
      if (this.proofTypes[row].proofType == "Membership") { this.entity.Membership = this.proofTypes[row].value }
      if (this.proofTypes[row].proofType == "FI") { this.entity.FormsFiled = this.proofTypes[row].value }

    }
  }

  save(event: any, type: any): void {

    this.saveDisabled = true;

    let validations = this._coreSaveService.saveValidation(this.entity);

    for (let row = 0; row < this.proofTypes.length; row++) {
      if (this.proofTypes[row].proofType == "DIN") {
        if (this.proofTypes[row].value == null || this.proofTypes[row].value == "" || this.proofTypes[row].value == undefined) {
          this.notification.showWarning("DIN is required")
          this.saveDisabled = false;
          return
        }
      }
      if (this.proofTypes[row].proofType == "PAN") {
        if (this.proofTypes[row].value == null || this.proofTypes[row].value == "" || this.proofTypes[row].value == undefined) {
          this.notification.showWarning("PAN is required")
          this.saveDisabled = false;
          return
        }
      }
      if (this.proofTypes[row].proofType == "Aadhaar") {
        if (this.proofTypes[row].value == null || this.proofTypes[row].value == "" || this.proofTypes[row].value == undefined) {
          this.notification.showWarning("Aadhaar is required")
          this.saveDisabled = false;
          return
        }
      }
      if (this.proofTypes[row].proofType == "DOB") {
        if (this.proofTypes[row].value == null || this.proofTypes[row].value == "" || this.proofTypes[row].value == undefined) {
          this.notification.showWarning("DOB is required")
          this.saveDisabled = false;
          return
        }
        localStorage.setItem('DOB', this.proofTypes[row].value)

      }

      if (this.proofTypes[row].proofType == "DOA") {
        if (this.proofTypes[row].value == null || this.proofTypes[row].value == "" || this.proofTypes[row].value == undefined) {
          this.notification.showWarning("Date of Appointment is required")
          this.saveDisabled = false;
          return
        }

        if ((this.getUTCDate(new Date(this.proofTypes[row].value)) < this.getUTCDate(new Date(localStorage.getItem('DOB')!)))) {
          this.notification.showWarning("Date of Appointment should not be earlier than DOB")
          this.saveDisabled = false
          return
        }
        localStorage.setItem('DOA', this.proofTypes[row].value)

      }
      if (this.proofTypes[row].proofType == "ReAppointmentDate") {
        if (this.proofTypes[row].value == null || this.proofTypes[row].value == "" || this.proofTypes[row].value == undefined) {
          this.notification.showWarning("ReAppointment Date is required")
          this.saveDisabled = false
          return
        }

        if ((this.getUTCDate(new Date(this.proofTypes[row].value)) < this.getUTCDate(new Date(localStorage.getItem('DOA')!)))) {
          this.notification.showWarning("Date of ReAppointment should not be earlier than Date of Appointment")
          this.saveDisabled = false
          return
        }

      }
    }
    for (let row = 0; row < this.proofTypes.length; row++) {
      if (this.proofTypes[row].proofType == "DIN") {
        if (this.proofTypes[row].value.length != 8) {
          this.notification.showWarning("Invalid DIN No.");
          this.saveDisabled = false;
          return;
        }
      }
    }
    if (validations.length === 0) {
      const pannum = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      for (let row = 0; row < this.proofTypes.length; row++) {
        if (this.proofTypes[row].proofType == "PAN") {
          this.panCheck = pannum.test(String(this.proofTypes[row].value).toString());
          if (this.panCheck == false) {
            this.notification.showWarning("Invalid PAN No.");
            this.saveDisabled = false;
            return;
          }
        }
      }
      // const aadharnum = /^[2-9]{1}[0-9]{3}[ ][0-9]{4}[ ][0-9]{4}$/;
      // const aadharnum = /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/
      const aadharnum = /^[2-9]\d{3}([ -]?)\d{4}\1\d{4}$/;
      for (let row = 0; row < this.proofTypes.length; row++) {
        if (this.proofTypes[row].proofType == "Aadhaar") {
          this.aadharCheck = aadharnum.test(String(this.proofTypes[row].value).toString());
          if (this.aadharCheck == false) {
            this.notification.showWarning("Invalid Aadhaar No.");
            this.saveDisabled = false;
            return;
          }
        }
      }

      if (this.entity.EmailId != "") {
        // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; commented on 04-06-2024 by jessil for #I238
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
        if (this.emailcheck === false) {
          this.notification.showWarning("Email not valid");
          this.saveDisabled = false;
          return;
        }
      }
      if (this.entity.Phone != "") {
        if (this.entity.Phone.length != 10) {
          this.notification.showWarning("Invalid Phone No.");
          this.saveDisabled = false;
          return;
        }
      }
      // if(this.entity.DOB>this.entity.AppointmentDate){
      // this.notification.showWarning("Appoinment date should be greater than the DOB")
      // this.saveDisabled=false;
      // return
      // }
      //  else {
      //    this._directorService.checkEmail(this.entity.EmailId, this.entity.Director_Id).subscribe((response) => {
      //      if (response.Success == false) {
      //        this.notification.showWarning("Email already exists");
      //        this.saveDisabled = false;
      //        return;
      //      }

      this._directorService.checkDuplication(this.entity.DirectorName, this.entity.Director_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Director already exists');
          this.saveDisabled = false;
        }
        else {
          for (let row = 0; row < this.proofTypes.length; row++) {

            if (this.proofTypes[row].proofType == "DIN") {
              this.entity.DIN = this.proofTypes[row].value;

            }

            if (this.proofTypes[row].proofType == "PAN") {
              this.entity.PAN = this.proofTypes[row].value

            }
            if (this.proofTypes[row].proofType == "Aadhaar") { this.entity.Aadhar = this.proofTypes[row].value }
            if (this.proofTypes[row].proofType == "DOB") { this.entity.DOB = this.getUTCDate(new Date(this.proofTypes[row].value)) }
            if (this.proofTypes[row].proofType == "DOA") { this.entity.AppointmentDate = this.getUTCDate(new Date(this.proofTypes[row].value)) }
            if (this.proofTypes[row].proofType == "Membership") { this.entity.Membership = this.proofTypes[row].value }
            if (this.proofTypes[row].proofType == "FI") { this.entity.FormsFiled = this.proofTypes[row].value }
            if (this.proofTypes[row].proofType == "ReAppointmentDate") { this.entity.ReAppointmentDate = this.getUTCDate(new Date(this.proofTypes[row].value)) }
            //   }
            // }); 
            if (row == this.proofTypes.length - 1) {
              this._directorService.saveDirector(this.initializeSaveEntity(this.entity)).subscribe((result: any) => {
                if (this.entity.Director_Id == "00000000-0000-0000-0000-000000000000") {
                  this.entity.Director_Id = result[0].ReqDirector_Id;
                  this.notification.showSuccess('Saved Successfully');

                }
                else {
                  this.notification.showSuccess('Updated Successfully');
                  // this.listView = true;
                  // this.clearDirector();
                  this.getAllDirectors();

                }
                // this.clearDirector();
              })
            }
          }
        }
      })
    }
    else {
      this.saveDisabled = false;
    }
  }


  save_Qualifications(event: any, entities_EDU: any): void {
    // this.saveDisabled = true;
    // this.EduDisabled=true;
    var flagEdu = 0;
    this.entity.DirectorEducationalQualification = [];
    for (let i = 0; i < this.entities_EDU.length; i++) {
      this.entity.DirectorEducationalQualification.push({
        QualificationName: this.entities_EDU[i].QualificationName,
        Director_Id: this.entity.Director_Id,
        Qualification_Id: this.entities_EDU[i].Qualification_Id,
        Qualification_Ref_Id:this.entities_EDU[i].IndexDocument&&this.entities_EDU[i].IndexDocument.Qualification_Ref_Id,
        EntityMetaData: [],
        IndexDocument:"",
      });
    }

    if (this.entity.Director_Id == "00000000-0000-0000-0000-000000000000") {
      this.notification.showWarning('Please Fill Director details');
      // this.saveDisabled = false;
      return
    }
    else {
      if (this.entity.DirectorEducationalQualification.length == 0) {
        this.notification.showWarning('Please Add Field');
        // this.saveDisabled = false;
        return

      }
      else {
        for (let i = 0; i < this.entities_EDU.length; i++) {
          if ((this.entities_EDU[i].QualificationName == undefined || this.entities_EDU[i].QualificationName == '') && this.entity.Director_Id != "00000000-0000-0000-0000-000000000000") {
            // this.EduDisabled = true;
            flagEdu = 1;
            this.notification.showWarning('Please Add Qualification');
            // this.saveDisabled = false;
            break;
          }
        }
      }
    }
    if (this.entity.Director_Id != "00000000-0000-0000-0000-000000000000" && flagEdu != 1) {

      this._directorService.saveQualification(this.entity.DirectorEducationalQualification).subscribe(() => {

        // else {

        this.notification.showSuccess('Saved Successfully');
        this.EduDisabled = true;
        // this.clearDirector();
        return
        // }
      })

    }

    // this.saveDisabled = false;

  }


  save_Professional(event: any, entities_PRO: any): void {
    // this.saveDisabled = true;
    var flagExp = 0;
    this.entity.DirectorProfessionalExperience = [];
    for (let i = 0; i < this.entities_PRO.length; i++) {
      this.entity.DirectorProfessionalExperience.push({
        ProfessionalName: this.entities_PRO[i].ProfessionalName,
        Professional_Id: this.entities_PRO[i].Professional_Id,
        Director_Id: this.entity.Director_Id,
        Professional_Ref_Id:this.entities_PRO[i].IndexDocument&&this.entities_PRO[i].IndexDocument.Professional_Ref_Id,
        Experience_Year: this.entities_PRO[i].Experience_Year,
        EntityMetaData: [],
        IndexDocument:""
      });

    }

    if (this.entity.Director_Id == "00000000-0000-0000-0000-000000000000") {
      this.notification.showWarning('Please Fill Director details');
      // this.saveDisabled = false;
      return
    }
    else if (this.entity.DirectorProfessionalExperience.length == 0) {
      this.notification.showWarning('Please Add Field');
      // this.saveDisabled = false;
      return
    }

    else {
      for (let i = 0; i < this.entities_PRO.length; i++) {
        if ((this.entities_PRO[i].ProfessionalName == undefined || this.entities_PRO[i].ProfessionalName == '' || this.entities_PRO[i].Experience_Year == undefined || this.entities_PRO[i].Experience_Year == 0) && this.entity.Director_Id != "00000000-0000-0000-0000-000000000000") {
          // this.EduDisabled = true;
          flagExp = 1;
          this.notification.showWarning('Please  Fill all Fields');
          // this.saveDisabled = false;
          break;
        }
      }
    }

    if (this.entity.Director_Id != "00000000-0000-0000-0000-000000000000" && flagExp != 1) {
      this._directorService.save_Professional(this.entity.DirectorProfessionalExperience).subscribe(() => {
        // else {
        this.notification.showSuccess('Saved Successfully');
        this.ProDisabled = true;
        return
        // }
        // this.clearDirector();
        // this.getAllDirectors();
      })
    }

  }



  save_Forms(event: any, entities_FORMS: any): void {
    // this.saveDisabled = true;
    var flagForms = 0;
    this.entity.DirectorFormsFiledAndIntimations = [];
    for (let i = 0; i < this.entities_FORMS.length; i++) {
      this.entity.DirectorFormsFiledAndIntimations.push({
        FormFiledName: this.entities_FORMS[i].FormFiledName,
        FormsFiled_Id: this.entities_FORMS[i].FormsFiled_Id,
        FormFiled_Ref_Id:this.entities_FORMS[i].IndexDocument&&this.entities_FORMS[i].IndexDocument.FormFiled_Ref_Id,
        Director_Id: this.entity.Director_Id,
        EntityMetaData: [],
        IndexDocument:""
      });

    }


    if (this.entity.Director_Id == "00000000-0000-0000-0000-000000000000") {
      this.notification.showWarning('Please Fill Director details');
      // this.saveDisabled = false;
      return;
    }
    else if (this.entity.DirectorFormsFiledAndIntimations.length == 0) {
      // this.saveDisabled = false;
      this.notification.showWarning('Please Add Field');
      return
    }

    else {
      for (let i = 0; i < this.entities_FORMS.length; i++) {
        if ((this.entities_FORMS[i].FormFiledName == undefined || this.entities_FORMS[i].FormFiledName == '') && this.entity.Director_Id != "00000000-0000-0000-0000-000000000000") {
          this.notification.showWarning('Please  Add Form Filed Name');
          flagForms = 1;
          break;
          // this.saveDisabled = false;
        }
      }
    }

    if (this.entity.Director_Id != "00000000-0000-0000-0000-000000000000" && flagForms != 1) {
      this._directorService.save_Forms(this.entity.DirectorFormsFiledAndIntimations).subscribe((result: any) => {
        this.notification.showSuccess('Saved Successfully');
        this.FormDisabled = true;
        return
      })
    }
  }
  save_OtherEnclosure(event: any, entities_OTHER: any): void {
    // this.saveDisabled = true;
    var flagOther = 0;
    this.entity.DirectorOtherEnclosure = [];
    for (let i = 0; i < this.entities_OTHER.length; i++) {
      this.entity.DirectorOtherEnclosure.push({
        DirectorEnclosure_Id: this.entities_OTHER[i].DirectorEnclosure_Id,
        DirectorEnclosure_Ref_Id: this.entities_OTHER[i].IndexDocument&&this.entities_OTHER[i].IndexDocument.DirectorEnclosure_Ref_Id,
        Tittle: this.entities_OTHER[i].Tittle,
        Director_Id: this.entity.Director_Id,
        EntityMetaData: [],
        IndexDocument:""

      });
    }

    if (this.entity.Director_Id == "00000000-0000-0000-0000-000000000000") {
      this.notification.showWarning('Please Fill Director details');
      return
      // this.saveDisabled = false;
    }
    else if (this.entity.DirectorOtherEnclosure.length == 0) {
      // this.saveDisabled = false;
      this.notification.showWarning('Please  Add  Field');
      return
    }

    else {
      for (let i = 0; i < this.entities_OTHER.length; i++) {
        if ((this.entities_OTHER[i].Tittle == undefined || this.entities_OTHER[i].Tittle == '') && this.entity.Director_Id != "00000000-0000-0000-0000-000000000000") {
          flagOther = 1;
          this.notification.showWarning('Please  Add  OtherEnclosures');
          this.saveDisabled = false;
          break;
          // this.OtherDisabled = true;
        }
      }
    }
    if (this.entity.Director_Id != "00000000-0000-0000-0000-000000000000" && flagOther != 1) {
      this._directorService.save_OtherEnclosure(this.entity.DirectorOtherEnclosure).subscribe((result: any) => {
        this.notification.showSuccess('Saved Successfully');
        this.listView = true;
        this.clearDirector();
        this.getAllDirectors();
      });
    }
  }

  save_all(event: any): void {
    if (this.entity.Director_Id != '00000000-0000-0000-0000-000000000000' && this.entity.Director_Id != null) {
      this.notification.showSuccess('Saved Successfully');
    }
    this.clearDirector();
    this.listView = true;
    this.getAllDirectors()
  }



  gotoBack(): void {
    this.listView = true;
    this.clearDirector();
  }
  refreshDirector(event: any): void {
    this.getAllDirectors();
  }
  clearDirector(): void {
    this.entity = new Director();
    this.saveDisabled = false;
    this.selectedDesignation = {};
    this.DINdownload = ""; this.Aadhaardownload = ""; this.PANdownload = ""; this.DOAdownload = ""; this.DOBdownload = "";
    this.ReAppointmentDatedownload = ""; this.Membershipdownload = "";
    this.proofTypes = [
      { proofType: "DIN", displayName: "DIN", description: "Enter the DIN", value: "", Istextbox: true, maxlength: 8 },
      { proofType: "Aadhaar", displayName: "Aadhaar", description: "Enter the Aadhar", value: "", Istextbox: true, maxlength: 14 },
      { proofType: "PAN", displayName: "PAN", value: "", description: "Enter the PAN", Istextbox: true, maxlength: 10 },
      { proofType: "DOB", displayName: "DOB", value: "", description: "Enter the DOB", Istextbox: false },
      { proofType: "DOA", displayName: "Date of Appointment", description: "Enter the Date of Appointment", value: "", Istextbox: false },
      { proofType: "ReAppointmentDate", displayName: "Date of Re-Appointment", description: "Enter the Date of Re-Appointment", value: "", Istextbox: false },
      { proofType: "Membership", displayName: "Membership", value: 0, Istextbox: false }
    ]
    this.entities_EDU = [];
    this.entities_PRO = [];
    this.entities_FORMS = [];
    this.entities_OTHER = [];
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  fileChanged(event: any, dataItem: any,rowIndex:any) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && event.target.files[0].type != 'application/pdf') {
        this.notification.showWarning('Choose correct File Format');
      }
      if (event.target.files[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || event.target.files[0].type == 'application/pdf') {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        this.entity.Document = event.target.files[0];

        const link: any = document.getElementById("link" + rowIndex)
        link.download = this.entity.Document.name;
        link.href = URL.createObjectURL(event.target.files[0])
        // this.dataItemdonload=this.entity.Document.name;
        reader.onload = (event) => {
          dataItem.url = String(event.target?.result);
          dataItem.button = true;
        }
        
        dataItem.IndexDocument=event.target.files[0]
        this.fileUploader.upload(  dataItem.IndexDocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            dataItem.IndexDocument.Qualification_Ref_Id = result.documentId;
            // this.entity.CompanyAddress=
          }
        })


     
        // for(let index=dataItem;index< this.entity.DirectorEducationalQualification.length;index++)
        // this.fileUploader.upload(this.entity.DirectorEducationalQualification[dataItem].IndexDocument, '').subscribe((result: any) => {
        //   if (result.succeeded) {
        //     this.entity.DirectorEducationalQualification[dataItem].Qualification_Ref_Id = result.documentId;
        //     // this.entity.CompanyAddress=
        //   }
        // })


      }
    }
  }

  professionalfileChanged(event: any, dataItem: any,rowIndex:any) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && event.target.files[0].type != 'application/pdf') {
        this.notification.showWarning('Choose correct File Format');
      }
      if (event.target.files[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || event.target.files[0].type == 'application/pdf') {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        this.entity.Document = event.target.files[0];

        const link: any = document.getElementById("link" + rowIndex)
        link.download = this.entity.Document.name;
        link.href = URL.createObjectURL(event.target.files[0])
        // this.dataItemdonload=this.entity.Document.name;
        reader.onload = (event) => {
          dataItem.url = String(event.target?.result);
          dataItem.button = true;
        }
        
        dataItem.IndexDocument=event.target.files[0]
        this.fileUploader.upload(  dataItem.IndexDocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            dataItem.IndexDocument.Professional_Ref_Id = result.documentId;
            // this.entity.CompanyAddress=
          }
        })


      }
    }
  }

  formsfileChanged(event: any, dataItem: any,rowIndex:any) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && event.target.files[0].type != 'application/pdf') {
        this.notification.showWarning('Choose correct File Format');
      }
      if (event.target.files[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || event.target.files[0].type == 'application/pdf') {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        this.entity.Document = event.target.files[0];

        const link: any = document.getElementById("link" + rowIndex)
        link.download = this.entity.Document.name;
        link.href = URL.createObjectURL(event.target.files[0])
        // this.dataItemdonload=this.entity.Document.name;
        reader.onload = (event) => {
          dataItem.url = String(event.target?.result);
          dataItem.button = true;
        }
        
        dataItem.IndexDocument=event.target.files[0]
        this.fileUploader.upload(  dataItem.IndexDocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            dataItem.IndexDocument.FormFiled_Ref_Id = result.documentId;
            // this.entity.CompanyAddress=
          }
        })


      }
    }
  }


  fileChangedother(event: any,rowIndex:any,dataItem: any) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && event.target.files[0].type != 'application/pdf') {
        this.notification.showWarning('Choose correct File Format');
      }
      if (event.target.files[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || event.target.files[0].type == 'application/pdf') {

        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);


        reader.onload = (event) => {
          this.url_ = String(event.target?.result);
          this.isButtonVisible = true;
        }
        this.entity.Document_Other = event.target.files[0];
        const link: any = document.getElementById("link" + rowIndex)
        link.download = this.entity.Document_Other.name;
        link.href = URL.createObjectURL(event.target.files[0])

        dataItem.IndexDocument=event.target.files[0]
        this.fileUploader.upload(  dataItem.IndexDocument, '').subscribe((result: any) => {
          if (result.succeeded) {
            dataItem.IndexDocument.DirectorEnclosure_Ref_Id = result.documentId;
            // this.entity.CompanyAddress=
          }
        })

        // const DocumentEdu=[];
       

      }
    }
  }
  removeImage(event: any) {
    this.url = '';
    this.isButtonVisible = false;
    this.entity.Document_Other = null;
  }
  file_Changed(event: any, url: any) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && event.target.files[0].type != 'application/pdf') {
        this.notification.showWarning('Choose correct File Format');
      }
      if (event.target.files[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || event.target.files[0].type == 'application/pdf') {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          this.url_DIN = String(event.target?.result);
          this.isButtonVisible_din = true;
        }
        this.entity.Document_Other = event.target.files[0];
      }
    }
  }
  remove_Image(event: any, url: any) {
    this.url_DIN = '';
    this.isButtonVisible_din = false;
    this.entity.Document_Other = null;
  }



  getAllDesignations(filter: string) {
    this._designationService.getAllDesignation(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Designation>) => {
      this.designations = data;
    })
  }
  addnewrow_EDU() {
    this.EduDisabled = false;
    this.entities_EDU.push({});
  }
  deleteRow_EDU(rowIndex: number) {
    //this.personaldata = this.personaldata.splice(rowIndex, 1)
    this.entities_EDU.splice(rowIndex, 1);
  }

  addnewrow_PRO() {
    this.ProDisabled = false;
    this.entities_PRO.push({});
  }
  deleteRow_PRO(rowIndex: number) {
    //this.personaldata = this.personaldata.splice(rowIndex, 1)
    this.entities_PRO.splice(rowIndex, 1);
  }

  addnewrow_FORMS() {
    this.FormDisabled = false;
    this.entities_FORMS.push({});
  }
  deleteRow_FORMS(rowIndex: number) {
    //this.personaldata = this.personaldata.splice(rowIndex, 1)
    this.entities_FORMS.splice(rowIndex, 1);
  }

  addnewrow_OTHER() {
    this.OtherDisabled = false;
    this.entities_OTHER.push({});
  }
  deleteRow_OTHER(rowIndex: number) {

    this.entities_OTHER.splice(rowIndex, 1);
  }
  dirfileChanged(event: any, type: any): void {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && event.target.files[0].type != 'application/pdf') {
        this.notification.showWarning('Choose correct File Format');
      }
      if (event.target.files[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || event.target.files[0].type == 'application/pdf') {

        var reader = new FileReader();

        type.Document = event.target.files[0];
        type.CiNdocument = event.target.files[0];


        if (type.proofType === "DIN") {
          this.entity.DINDocDownload = event.target.files[0]
          const DINlink: any = document.getElementById("DINlink")
          // let first=event.target.files[0]
          DINlink.download = this.entity.DINDocDownload.name;
          DINlink.href = URL.createObjectURL(this.entity.DINDocDownload)
          this.DINdownload = this.entity.DINDocDownload.name;
          this.fileUploader.upload(this.entity.DINDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.DIN_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.DINDocDownload);
        }
        else if (type.proofType === "Aadhaar") {
          this.entity.AdhaarDocDownload = event.target.files[0]
          const Aadhaarlink: any = document.getElementById("Aadhaarlink")
          // let first=event.target.files[0]
          Aadhaarlink.download = this.entity.AdhaarDocDownload.name;
          Aadhaarlink.href = URL.createObjectURL(this.entity.AdhaarDocDownload)
          this.Aadhaardownload = this.entity.AdhaarDocDownload.name;
          this.fileUploader.upload(this.entity.AdhaarDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.Aadhar_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.AdhaarDocDownload);
        }
        else if (type.proofType === "PAN") {
          this.entity.PANDocDownload = event.target.files[0]
          const PANlink: any = document.getElementById("PANlink")
          // let first=event.target.files[0]
          PANlink.download = this.entity.PANDocDownload.name;
          PANlink.href = URL.createObjectURL(this.entity.PANDocDownload)
          this.PANdownload = this.entity.PANDocDownload.name;
          this.fileUploader.upload(this.entity.PANDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.PAN_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL( this.entity.PANDocDownload);
        }
        else if (type.proofType === "DOB") {
          this.entity.DOBDocDownload = event.target.files[0]
          const DOBlink: any = document.getElementById("DOBlink")
          // let first=event.target.files[0]
          DOBlink.download = this.entity.DOBDocDownload.name;
          DOBlink.href = URL.createObjectURL(this.entity.DOBDocDownload)
          this.DOBdownload = this.entity.DOBDocDownload.name;
          this.fileUploader.upload(this.entity.DOBDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.DOB_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.DOBDocDownload);
        }
        else if (type.proofType === "DOA") {
          this.entity.DOADocDownload = event.target.files[0]
          const DOAlink: any = document.getElementById("DOAlink")
          // let first=event.target.files[0]
          DOAlink.download = this.entity.DOADocDownload.name;
          DOAlink.href = URL.createObjectURL(this.entity.DOADocDownload)
          this.DOAdownload = this.entity.DOADocDownload.name;
          this.fileUploader.upload(this.entity.DOADocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.AppointmentDate_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.DOADocDownload);
        }
        else if (type.proofType === "ReAppointmentDate") {
          this.entity.ReAppointmentDateDocDownload = event.target.files[0]
          const ReAppointmentDatelink: any = document.getElementById("ReAppointmentDatelink")
          // let first=event.target.files[0]
          ReAppointmentDatelink.download = this.entity.ReAppointmentDateDocDownload.name;
          ReAppointmentDatelink.href = URL.createObjectURL(this.entity.ReAppointmentDateDocDownload)
          this.ReAppointmentDatedownload = this.entity.ReAppointmentDateDocDownload.name;
          this.fileUploader.upload(this.entity.ReAppointmentDateDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.ReAppointmentDate_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL( this.entity.ReAppointmentDateDocDownload);
        }
        else if (type.proofType === "Membership") {
          this.entity.MembershipDocDownload = event.target.files[0]
          const Membershiplink: any = document.getElementById("Membershiplink")
          // let first=event.target.files[0]
          Membershiplink.download = this.entity.MembershipDocDownload.name;
          Membershiplink.href = URL.createObjectURL(this.entity.MembershipDocDownload)
          this.Membershipdownload = this.entity.MembershipDocDownload.name;
          this.fileUploader.upload(this.entity.MembershipDocDownload, '').subscribe((result: any) => {
            if (result.succeeded) {
              this.entity.Membership_Ref_Id = result.documentId;
              // this.entity.CompanyAddress=
            }
          })
          // URL.revokeObjectURL(this.entity.MembershipDocDownload);
        }

        reader.onload = (event) => {

          type.url = String(event.target?.result);
          type.button = true;


          event.preventDefault();
        }
        reader.readAsDataURL(event.target.files[0]);

      }
      this.savedoc = true;
    }
  }


  downloadFunction(type: any): void {
    // let documentId = entity.Ref_Id;
    if (type.proofType === "Aadhaar") {

      if(this.entity.Aadhar_Ref_Id!=null && this.entity.AadhaarFileName!=null){
        const file = [];
        file.push({
          FileName: this.entity.AadhaarFileName,
          Ref_Id: this.entity.Aadhar_Ref_Id
        });
        this.documentdownloadservice.downloadFile(file[0])
      }
      else{
        this.notification.showWarning('No documents found');
      }


      
    }
    else if (type.proofType === "DIN") {
      if(this.entity.DIN_Ref_Id!=null && this.entity.DINFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.DINFileName,
        Ref_Id: this.entity.DIN_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
  }
    else if (type.proofType === "PAN") {
      if(this.entity.PAN_Ref_Id!=null && this.entity.PANFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.PANFileName,
        Ref_Id: this.entity.PAN_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
      else{
        this.notification.showWarning('No documents found');
      }
    }
    else if (type.proofType === "DOB") {
      if(this.entity.DOB_Ref_Id!=null && this.entity.DOBFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.DOBFileName,
        Ref_Id: this.entity.DOB_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');

    }
   }
    else if (type.proofType === "DOA") {
      if(this.entity.AppointmentDate_Ref_Id!=null && this.entity.DOAFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.DOAFileName,
        Ref_Id: this.entity.AppointmentDate_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
  }

    else if (type.proofType === "ReAppointmentDate") {
      if(this.entity.ReAppointmentDate_Ref_Id!=null && this.entity.ReAppointmentDateFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.ReAppointmentDateFileName,
        Ref_Id: this.entity.ReAppointmentDate_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }

    else if (type.proofType === "Membership") {
      if(this.entity.Membership_Ref_Id!=null && this.entity.MembershipFileName!=null){
      const file = [];
      file.push({
        FileName: this.entity.MembershipFileName,
        Ref_Id: this.entity.Membership_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
  }
  else{
    this.notification.showWarning('No documents found');
  }
  }
  TabdownloadFunction(entity:any,rowIndex:any){

  }


  removedirImage(event: any, type: any): void {
    type.url = ''
    type.button = false;

  }
  goToNextTab(): void {
    if (this.aciveTab != 5) {
      this.aciveTab++;
      let element = document.getElementById('tab' + this.aciveTab);
      if (element)
        element.click();
    }
  }
  goToBackTab(): void {
    if (this.aciveTab != 1) {
      this.aciveTab--;
      let element = document.getElementById('tab' + this.aciveTab);
      if (element)
        element.click();
    }
    else {
      this.listView = true;
    }
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Director_Id = dataItem.Director_Id;
    this.details = [];
    this._directorService.viewDirector(this.entity.Director_Id).subscribe((director: any) => {
      this.opened = true;
      this.details = director;
      // console.log((this.details));
      this.details.Membership == true ? this.details.Membership = "Yes" : this.details.Membership = "No";
      this.EduQualificationCaption = 'Educational Qualification';
      this.ProExperienceCaption = 'Professional Experience';
      this.FormFiledCaption = 'Forms Filed and Intimations';
      this.OtherEnclosureCaption = 'Other Enclosure';
    })
  }

  edudownloadFunction(type: any,dataItem:any): void {
    // if (type.proofType === "address") {
    if(this.entities_EDU[dataItem].Qualification_Ref_Id!=null && this.entities_EDU[dataItem].qualificationFileName!=null){
      const file = [];
      file.push({
        FileName: this.entities_EDU[dataItem].qualificationFileName,
        Ref_Id: this.entities_EDU[dataItem].Qualification_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    
  }
  professionaldownloadFunction(type: any,dataItem:any): void {
      if(this.entities_PRO[dataItem].Professional_Ref_Id!=null && this.entities_PRO[dataItem].professionalFileName!=null){
      const file = [];
      file.push({
        FileName: this.entities_PRO[dataItem].professionalFileName,
        Ref_Id: this.entities_PRO[dataItem].Professional_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }
  
  formsdownloadFunction(type: any,dataItem:any): void {
      if(this.entities_FORMS[dataItem].FormFiled_Ref_Id!=null && this.entities_FORMS[dataItem].FormsFileName!=null){
      const file = [];
      file.push({
        FileName: this.entities_FORMS[dataItem].FormsFileName,
        Ref_Id: this.entities_FORMS[dataItem].FormFiled_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }
    // else if (type.proofType === "TAN") {
      Otherdownload(type: any,dataItem:any):void{
      if(this.entities_OTHER[dataItem].DirectorEnclosure_Ref_Id!=null && this.entities_OTHER[dataItem].enclosureFileName!=null){
      const file = [];
      file.push({
        FileName: this.entities_OTHER[dataItem].enclosureFileName,
        Ref_Id: this.entities_OTHER[dataItem].DirectorEnclosure_Ref_Id
      });
      this.documentdownloadservice.downloadFile(file[0])
    }
    else{
      this.notification.showWarning('No documents found');
    }
    }
  


}
